import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFetch } from "../custom/api";
import "../styles/Containers.css";
import ConfirmDelete from "../routes/grocery/components/ConfirmDelete";

const Accordion = ({ title, content, listId, groceryList, setGroceryList }) => {
  const { myFetch } = useFetch();
  const [isOpen, setIsOpen] = useState(true);
  const [showCModal, setShowCModal] = useState(false);
  const [checkedState, setCheckedState] = useState(
    content.map((e) => e.bought)
  );

  async function handleDeleteList() {
    let response = await myFetch(`grocery/${listId}`, {
      method: "DELETE",
    });
    let jsonResponse = await response.json();
    if (jsonResponse.status === "success") {
      toast.success(jsonResponse.message);
      setGroceryList(groceryList.filter((e) => e.name != listId));
    } else {
      toast.error(jsonResponse.message);
    }
  }

  const handleOnChange = async (position) => {
    let itemData = content[position];

    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );
    let response = await myFetch(
      `grocery-item/bought/${itemData.grocery_item_id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          new_value: !itemData.bought,
        }),
      }
    );
    let jsonResponse = await response.json();
    if (jsonResponse.status === "success") {
      toast.success(jsonResponse.message);
      setCheckedState(updatedCheckedState);
      itemData.bought = !itemData.bought;
    } else {
      toast.error(jsonResponse.message);
    }
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleCloseCModal = () => {
    setShowCModal(false);
  };

  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeButton={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      ></ToastContainer>
      {isOpen ? (
        <div
          className="accordion-header spc-between gRowHeader"
          onClick={handleToggle}
        >
          <div className="flex">
            <div className="paddingUpDown1">
              <span className="icon-calendarDefault heading-1 purple-1"></span>
            </div>
            <div className="heading-3">{title}</div>
          </div>
          {isOpen ? (
            <span className="icon-iconchevron-up heading-2 purple-1"></span>
          ) : (
            <span className="icon-iconchevron-down heading-2 purple-1"></span>
          )}
        </div>
      ) : (
        <div
          className="accordion-header spc-between gRowHeader radius1"
          onClick={handleToggle}
        >
          <div className="flex">
            <div className="paddingUpDown1">
              <span className="icon-calendarDefault heading-1 purple-1"></span>
            </div>
            <div className="heading-3">{title}</div>
          </div>
          {isOpen ? (
            <span className="icon-iconchevron-up heading-2 purple-1"></span>
          ) : (
            <span className="icon-iconchevron-down heading-2 purple-1"></span>
          )}
        </div>
      )}
      {isOpen && (
        <div className="accordion-content gRowBody">
          {content.map((elem, index) => {
            return (
              <div key={index}>
                <div className="spc-between paddingUpDown1">
                  <div
                    className={
                      elem.bought
                        ? "lineThrough grey-3 flex paddingUpDown3"
                        : "grey-1 flex paddingUpDown3"
                    }
                  >
                    <label className="container2">
                      <input
                        type="checkbox"
                        id={`custom-checkbox-${index}`}
                        checked={checkedState[index]}
                        onChange={() => handleOnChange(index)}
                        className="custom-checkbox"
                        name={elem.grocer_item_id}
                        value={elem.grocer_item_id}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <div className="paddingUpDown3 yekan caption-1">
                      {elem.item_name}{" "}({elem.recipe_name})
                    </div>
                  </div>

                  <div
                    className={
                      elem.bought
                        ? "lineThrough grey-3 yekan caption-1 paddingUpDown3"
                        : "yekan grey-2 caption-1 paddingUpDown3"
                    }
                  >
                    {elem.item_amount} {elem.unit_name}
                  </div>
                </div>
              </div>
            );
          })}
          <div
            className="marginBottom1 flexLeft"
            onClick={() => setShowCModal(true)}
          >
            <div className="b-grey-5 flex radius1 padding3 red-1">
              <span className="icon-icondelete heading-3"></span>
              <p className="caption-1 yekan">حذف لیست</p>
            </div>
          </div>
          <ConfirmDelete
            showCModal={showCModal}
            handleCloseCModal={handleCloseCModal}
            handleDeleteList={handleDeleteList}
          ></ConfirmDelete>
        </div>
      )}
    </div>
  );
};

export default Accordion;
